(function () {
  "use strict";

  var root = document.querySelector("[data-custom-gift-card]");
  if (!root) return;

  var form = root.querySelector("[data-gift-card-form]");
  if (!form) return;

  var endpoint    = root.dataset.endpoint || "";
  var currency    = root.dataset.currency || "INR";
  var locale      = root.dataset.locale   || "en-IN";

  /* ── DOM references ── */
  var valuePillsContainer = root.querySelector("[data-value-pills]");
  var formError           = root.querySelector("[data-form-error]");
  var payButton           = root.querySelector("[data-pay-now]");
  var messageField        = root.querySelector("[data-message]");
  var messageCount        = root.querySelector("[data-message-count]");
  var valueError          = root.querySelector("[data-value-error]");

  /* Slider elements */
  var designGrid  = root.querySelector("[data-design-grid]");
  var sliderPrev  = root.querySelector("[data-slider-prev]");
  var sliderNext  = root.querySelector("[data-slider-next]");
  var sliderDots  = root.querySelector("[data-slider-dots]");

  /* ── Product data from the embedded JSON ── */
  var productsDataEl = root.querySelector("script[type='application/json']");
  var allProducts    = [];
  try {
    allProducts = productsDataEl ? JSON.parse(productsDataEl.textContent || "[]") : [];
  } catch (e) {
    allProducts = [];
  }

  /* Active state tracking */
  var currentProduct = allProducts[0] || null;  // selected design
  var currentVariant = null;                     // selected value variant

  /* ── Helpers ── */
  function formatMoney(cents) {
    var amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(locale, {
        style: "currency",
        currency: currency,
        maximumFractionDigits: amount % 1 === 0 ? 0 : 2
      }).format(amount);
    } catch (_) {
      return currency + " " + amount.toFixed(2);
    }
  }

  function setFieldError(field, message) {
    var wrapper = field.closest("[data-field]");
    var errEl   = wrapper ? wrapper.querySelector("[data-error]") : null;
    if (errEl) errEl.textContent = message || "";
    field.setAttribute("aria-invalid", message ? "true" : "false");
  }

  function clearErrors() {
    root.querySelectorAll("[data-error]").forEach(function (el) { el.textContent = ""; });
    root.querySelectorAll("[aria-invalid]").forEach(function (el) { el.removeAttribute("aria-invalid"); });
    if (valueError) valueError.textContent = "";
    if (formError) {
      formError.textContent = "";
      formError.classList.remove("is-visible");
    }
  }

  function showFormError(msg) {
    if (!formError) return;
    formError.textContent = msg;
    formError.classList.add("is-visible");
  }

  function validateEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  }

  function validatePhone(v) {
    var digits = v.replace(/\D/g, "");
    return digits.length >= 10 && digits.length <= 15;
  }

  /* ── Render value pills (always via JS — no Liquid pre-render) ── */
  function renderValuePills(product) {
    if (!valuePillsContainer || !product) return;

    valuePillsContainer.innerHTML = "";
    currentVariant = null;

    /* All variants shown regardless of inventory — gift cards always continue selling */
    (product.variants || []).forEach(function (variant, idx) {
      var label = document.createElement("label");
      label.className = "custom-gift-card__pill-label" + (idx === 0 ? " is-selected" : "");

      var radio = document.createElement("input");
      radio.type      = "radio";
      radio.name      = "gift_card_value";
      radio.className = "custom-gift-card__value-radio";
      radio.setAttribute("data-value-radio", "");
      radio.dataset.variantId    = String(variant.id);
      radio.dataset.variantPrice = String(variant.price);
      radio.dataset.variantTitle = variant.title || "";
      radio.value = String(variant.id);
      if (idx === 0) {
        radio.checked  = true;
        currentVariant = variant;
      }

      var span = document.createElement("span");
      span.textContent = formatMoney(variant.price);

      label.appendChild(radio);
      label.appendChild(span);
      valuePillsContainer.appendChild(label);
    });
  }

  /* ── Event: value pill changed ── */
  function onValueChange(target) {
    root.querySelectorAll(".custom-gift-card__pill-label").forEach(function (lbl) {
      lbl.classList.remove("is-selected");
    });

    var checkedRadio = target || (valuePillsContainer ? valuePillsContainer.querySelector("[data-value-radio]:checked") : null);
    if (checkedRadio) {
      checkedRadio.parentElement.classList.add("is-selected");
      currentVariant = {
        id:    checkedRadio.dataset.variantId,
        price: Number(checkedRadio.dataset.variantPrice),
        title: checkedRadio.dataset.variantTitle
      };
    }
  }

  /* ── Slider helpers ── */

  function getDesignCards() {
    return designGrid ? Array.from(designGrid.querySelectorAll(".custom-gift-card__design-label")) : [];
  }

  function renderSliderDots() {
    if (!sliderDots) return;
    var cards = getDesignCards();
    sliderDots.innerHTML = "";
    cards.forEach(function (_, idx) {
      var dot = document.createElement("button");
      dot.type = "button";
      dot.className = "custom-gift-card__slider-dot" + (idx === 0 ? " is-active" : "");
      dot.setAttribute("aria-label", "Design " + (idx + 1));
      dot.addEventListener("click", function () {
        scrollToCard(idx);
        updateActiveDot(idx);
        /* also select the radio for that card */
        var radio = cards[idx] ? cards[idx].querySelector("[data-design-radio]") : null;
        if (radio && !radio.checked) {
          radio.checked = true;
          onDesignChange(radio);
        }
      });
      sliderDots.appendChild(dot);
    });
  }

  function updateActiveDot(activeIdx) {
    if (!sliderDots) return;
    sliderDots.querySelectorAll(".custom-gift-card__slider-dot").forEach(function (dot, i) {
      dot.classList.toggle("is-active", i === activeIdx);
    });
  }

  function scrollToCard(idx) {
    if (!designGrid) return;
    var cards = getDesignCards();
    if (!cards[idx]) return;
    /* scroll so the card is centred in the viewport */
    cards[idx].scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
  }

  function getActiveCardIndex() {
    var cards = getDesignCards();
    for (var i = 0; i < cards.length; i++) {
      var radio = cards[i].querySelector("[data-design-radio]");
      if (radio && radio.checked) return i;
    }
    return 0;
  }

  function updateSliderArrows() {
    if (!sliderPrev || !sliderNext || !designGrid) return;
    var idx = getActiveCardIndex();
    var total = getDesignCards().length;
    sliderPrev.disabled = idx <= 0;
    sliderNext.disabled = idx >= total - 1;
  }

  /* ── Event: design radio changed ── */
  function onDesignChange(radio) {
    var productId = Number(radio.dataset.productId);
    currentProduct = allProducts.find(function (p) { return p.id === productId; }) || currentProduct;
    renderValuePills(currentProduct);
    syncDesignLabels();
    updateSliderArrows();
    updateActiveDot(getActiveCardIndex());
  }

  function syncDesignLabels() {
    root.querySelectorAll("[data-design-radio]").forEach(function (radio) {
      var lbl = radio.closest(".custom-gift-card__design-label");
      if (lbl) lbl.classList.toggle("is-active", radio.checked);
    });
  }

  /* ── Validation ── */
  function validateForm() {
    var valid = true;
    clearErrors();

    /* Must have a design selected */
    var checkedDesign = root.querySelector("[data-design-radio]:checked");
    if (!checkedDesign) {
      var selectorErr = root.querySelector(".custom-gift-card__selector-error[data-error]");
      if (selectorErr) selectorErr.textContent = "Please select a gift card design.";
      valid = false;
    }

    /* Must have a variant pill selected */
    if (!currentVariant) {
      if (valueError) valueError.textContent = "Please choose a gift card value.";
      valid = false;
    }

    /* Required text/email fields */
    form.querySelectorAll("[data-required]").forEach(function (field) {
      var val = field.value.trim();
      if (!val) {
        setFieldError(field, "This field is required.");
        valid = false;
        return;
      }
      if (field.hasAttribute("data-email") && !validateEmail(val)) {
        setFieldError(field, "Enter a valid email address.");
        valid = false;
      }
      if (field.hasAttribute("data-phone") && !validatePhone(val)) {
        setFieldError(field, "Enter a valid 10-digit WhatsApp number.");
        valid = false;
      }
    });

    /* Confirm email must match */
    var emailField   = form.querySelector("[data-email]");
    var confirmField = form.querySelector("[data-confirm-email]");
    if (emailField && confirmField && emailField.value.trim() && confirmField.value.trim()) {
      if (emailField.value.trim() !== confirmField.value.trim()) {
        setFieldError(confirmField, "Email addresses do not match.");
        valid = false;
      }
    }

    /* Endpoint sanity check */
    if (!endpoint || endpoint.indexOf("AKfycbx...") !== -1) {
      showFormError("Gift card endpoint is not configured.");
      valid = false;
    }

    return valid;
  }

  /* ── Collect payload for Google Sheets ── */
  function collectPayload() {
    return {
      selected_product:   currentProduct ? currentProduct.title : "",
      product_id:         currentProduct ? currentProduct.id    : "",
      variant_id:         currentVariant ? currentVariant.id    : "",
      product_price:      currentVariant ? formatMoney(currentVariant.price) : "",
      recipient_name:     (form.elements.recipient_name     || {}).value || "",
      recipient_email:    (form.elements.recipient_email    || {}).value || "",
      recipient_whatsapp: (form.elements.recipient_whatsapp || form.elements.whatsapp_number || {}).value || "",
      sender_name:        (form.elements.sender_name        || {}).value || "",
      message:            (form.elements.message            || {}).value || "",
      timestamp:          new Date().toISOString(),
      current_store_url:  window.location.origin,
      page_url:           window.location.href
    };
  }

  /* ── Google Sheets POST ── */
  async function postToGoogleSheets(payload) {
    var response = await fetch(endpoint, {
      method: "POST",
      body: JSON.stringify(payload)
    });
    if (!response.ok) throw new Error("Unable to save gift card details.");
  }

  /* ── Shopify cart add ── */
  async function addToCart(payload) {
    var cartRoot = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/");

    if (!currentVariant) throw new Error("No gift card value selected.");

    var response = await fetch(cartRoot + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({
        id: Number(currentVariant.id),
        quantity: 1,
        properties: {
          "Recipient Name":     payload.recipient_name,
          "Recipient Email":    payload.recipient_email,
          "Recipient WhatsApp": payload.recipient_whatsapp,
          "From":               payload.sender_name,
          "Message":            payload.message
        }
      })
    });

    if (!response.ok) {
      /* Read the real Shopify error so the merchant can diagnose the root cause */
      var errBody = null;
      try { errBody = await response.json(); } catch (_) {}
      var errMsg = (errBody && (errBody.description || errBody.message))
                   || ("Cart error " + response.status + ": check variant inventory policy in Shopify admin.");
      throw new Error(errMsg);
    }
  }

  function setLoading(isLoading) {
    payButton.disabled    = isLoading;
    payButton.textContent = isLoading ? "Processing..." : "PROCEED TO BUY";
  }

  /* ── Event Listeners ── */

  /* Design radio buttons */
  root.querySelectorAll("[data-design-radio]").forEach(function (radio) {
    radio.addEventListener("change", function () {
      onDesignChange(radio);
    });
  });

  /* Slider arrow buttons */
  if (sliderPrev) {
    sliderPrev.addEventListener("click", function () {
      var cards = getDesignCards();
      var idx   = getActiveCardIndex();
      var target = Math.max(0, idx - 1);
      var targetRadio = cards[target] ? cards[target].querySelector("[data-design-radio]") : null;
      if (targetRadio && !targetRadio.checked) {
        targetRadio.checked = true;
        onDesignChange(targetRadio);
      }
      scrollToCard(target);
    });
  }

  if (sliderNext) {
    sliderNext.addEventListener("click", function () {
      var cards = getDesignCards();
      var idx   = getActiveCardIndex();
      var target = Math.min(cards.length - 1, idx + 1);
      var targetRadio = cards[target] ? cards[target].querySelector("[data-design-radio]") : null;
      if (targetRadio && !targetRadio.checked) {
        targetRadio.checked = true;
        onDesignChange(targetRadio);
      }
      scrollToCard(target);
    });
  }

  /* Value pills — delegated so it works after JS re-render */
  if (valuePillsContainer) {
    valuePillsContainer.addEventListener("change", function (e) {
      if (e.target && e.target.hasAttribute("data-value-radio")) {
        onValueChange(e.target);
      }
    });
  }

  /* Message character counter */
  if (messageField && messageCount) {
    var maxLen = Number(messageField.maxLength || 250);
    messageField.addEventListener("input", function () {
      var remaining = Math.max(0, maxLen - messageField.value.length);
      messageCount.textContent = "Character Limit: " + remaining;
    });
  }

  /* Form submit */
  form.addEventListener("submit", async function (event) {
    event.preventDefault();
    if (!validateForm()) return;

    setLoading(true);

    try {
      var payload = collectPayload();
      await postToGoogleSheets(payload);
      await addToCart(payload);
      window.location.href = "/checkout";
    } catch (error) {
      showFormError(error.message || "Submission failed. Please try again.");
      setLoading(false);
    }
  });

  /* ── Init: render pills for the first product immediately ── */
  if (currentProduct) {
    renderValuePills(currentProduct);
  }
  syncDesignLabels();
  renderSliderDots();
  updateSliderArrows();
  /* ensure first card is in view on load */
  scrollToCard(0);

})();
